import { TextAreaContent } from '../quill/converters/types';
import Event from './Event';
import Events from './Events';

export default class ContentChangeEvent extends Event {
    public content: TextAreaContent[];

    constructor(content: TextAreaContent[]) {
        super(Events.ContentChange);
        this.content = content;
    }
}
